module.exports = __webpack_public_path__ + "img/movieTheater-1.ca2d3a42.jpg";